import { useQuery } from "@tanstack/react-query";

import { useCurrentUser } from "@av/apps/common-apps/platform/services/authentication/user/current-user";
import { bffAxios } from "@av/config/api-config/axios-config";
import { COMPANY_DOCUMENTS_QUERY_KEY } from "../constants";

import type { ApiCollectionResponse, CompanyDocumentView } from "../types";

export function useFetchCompanyDocuments() {
  const { data: currentUser } = useCurrentUser();
  const companyId = currentUser?.company.id;

  return useQuery({
    queryKey: [...COMPANY_DOCUMENTS_QUERY_KEY, companyId] as const,
    enabled: Boolean(companyId),
    queryFn: async () => {
      const { data } =
        await bffAxios.get<ApiCollectionResponse<CompanyDocumentView>>("/company-documents");

      return data.items ?? [];
    },
  });
}
